import { render, staticRenderFns } from "./UserPreferences.vue?vue&type=template&id=150ac1b3&scoped=true"
import script from "./UserPreferences.vue?vue&type=script&lang=js"
export * from "./UserPreferences.vue?vue&type=script&lang=js"
import style0 from "./UserPreferences.vue?vue&type=style&index=0&id=150ac1b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150ac1b3",
  null
  
)

export default component.exports